export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-02.3959f531.svg";